import { FC, Suspense } from 'react';

import { classNames } from 'shared/utils/class-names';
import { MenuIcon } from 'shared/components/Icons';
import { Navigation } from 'shared/components/Sidebar/presets/Navigation';
import Logout from './Logout';
import Chat from './Chat';
import { SelectLanguage } from 'shared/components/SelectLanguage';

import classes from './styles.module.scss';
import { useLocation } from 'react-router-dom';
import { Urls } from 'shared/constants/urls';
import {
  CURRENT_AFFILIATE,
  getItemFromLocalStorage
} from 'shared/utils/local-storage';
import { isTestieAffiliate } from 'shared/constants/affiliates';
const TESTIE_CLINICAL_SUPPORT_NUMBER = '(855) 983-5347';

type THeaderProps = {
  showSideBar: boolean;
  setShowSideBar: (state: boolean) => void;
  isIframe?: boolean;
  isMobile: boolean;
};

const Header: FC<THeaderProps> = ({
  showSideBar,
  setShowSideBar,
  isIframe = false,
  isMobile
}) => {
  const { pathname } = useLocation();
  const currentAffiliate = getItemFromLocalStorage(CURRENT_AFFILIATE);
  const isTestie = isTestieAffiliate(currentAffiliate);
  return (
    <>
      <div
        className={classNames(classes.header, {
          [classes.inIframe]: isIframe && !isMobile
        })}
      >
        <div className={classes.menuIcons} onClick={() => setShowSideBar(true)}>
          <MenuIcon />
        </div>
        {pathname === Urls.Messages && (
          <div>
            <p className={classes.header_label}>
              Our patient care team is available 7am PDT - 4pm PDT (Monday -
              Friday, excluding holidays)
            </p>
            {isTestie && (
              <p className={classes.header_label}>
                Clinical Support Number: {TESTIE_CLINICAL_SUPPORT_NUMBER}
              </p>
            )}
          </div>
        )}
        {!isIframe && (
          <div className={classes.header__icons}>
            <SelectLanguage />
            <Chat />
            <Suspense>
              <Logout />
            </Suspense>
          </div>
        )}
        <Suspense>
          <Navigation
            showContent={showSideBar}
            setShowContent={setShowSideBar}
          />
        </Suspense>
      </div>
    </>
  );
};

export default Header;
